import { NavLink, Route, Routes } from "react-router-dom";
import { useLocation } from "react-router";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { getTranslatedText as translate } from "../Localization/Translation";
import Fees from "./Fees/Fees.js";
import Earnings from "./Earnings/Earnings.js";

const mainTabClick = (newClassName) => {
  var newTab = document.querySelector(newClassName);

  Array.from(document.querySelectorAll(".main-tab")).forEach(function (val) {
    val.style.fontWeight = "normal";
  });
  newTab.style.fontWeight = "bold";
};

const Accountant = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/Navbar/Accountant/Fees")
      mainTabClick(".Fees-main-tab");
    else if (location.pathname === "/Navbar/Accountant/Earnings")
      mainTabClick(".Earnings-main-tab");
  }, []);
  return (
    <div className="main-component">
      <div className="main-navbar" dir="auto">
        <NavLink
          to="/Navbar/Accountant/Fees"
          className="Fees-main-tab main-tab current-main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".Fees-main-tab")}
        >
          <span>{translate("commissions-and-taxes-tap", locale)}</span>
        </NavLink>
        <NavLink
          to="/Navbar/Accountant/Earnings"
          className="Earnings-main-tab main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".Earnings-main-tab")}
        >
          <span>{translate("earnings-calculate-tap", locale)}</span>
        </NavLink>
      </div>

      <Routes>
        <Route path="Fees/*" element={<Fees />} />
        <Route path="Earnings/*" element={<Earnings />} />
      </Routes>
    </div>
  );
};

export default Accountant;
